export function MembersSkeleton() {
  return (
    <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2">
      {[...Array(8)].map((_, index) => (
        <div key={index} className="h-[240px] w-full animate-pulse bg-neutral-50 sm:h-[252px]" />
      ))}
    </div>
  );
}
